/**
 * referralTracking.js — Capture le token ?ref= au load et le stocke
 * pour le passer au checkout Gumroad.
 *
 * Le token est valable 30 jours (rolling). Si l'utilisateur achète dans
 * cette fenêtre, on passe le ref dans custom_fields[refby] vers Gumroad
 * (côté URL d'achat ou via paymentLinks helper).
 */

const STORAGE_KEY = 'insidepanama_ref';
const EXPIRY_DAYS = 30;

export function captureReferralFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref || ref.length < 4 || ref.length > 32) return null;

    const expiresAt = Date.now() + EXPIRY_DAYS * 24 * 3600 * 1000;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ref, expiresAt }));
    return ref;
  } catch { return null; }
}

export function getActiveReferral() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { ref, expiresAt } = JSON.parse(raw);
    if (Date.now() > expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return ref;
  } catch { return null; }
}

export function appendReferralToCheckoutUrl(gumroadUrl) {
  const ref = getActiveReferral();
  if (!ref) return gumroadUrl;
  try {
    const url = new URL(gumroadUrl);
    url.searchParams.set('refby', ref);
    return url.toString();
  } catch { return gumroadUrl; }
}

export function clearReferral() {
  if (typeof window === 'undefined') return;
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}
